<template>
  <b-container class="d-flex flex-column mh-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Spoločnosti
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        />
      </div>
      <div v-if="$root.user.isAdmin" class="ml-3">
        <b-dropdown
          menu-class="dropdown-menu-animated"
          right
          size="lg"
          variant="secondary"
        >
          <template #button-content>
            <b-icon icon="gear" />
          </template>
          <b-dropdown-item-button @click="exportCompanies">
            <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
            Exportovať
          </b-dropdown-item-button>
        </b-dropdown>
        <b-btn
          class="text-uppercase"
          size="lg"
          variant="primary"
          @click="openAddCompanyModal"
        >
          <b-icon class="mr-1" icon="plus" scale="1.5x" />
          Nová spoločnosť
        </b-btn>
      </div>
    </div>
    <add-company ref="companyForm" />
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click="edit(data.item.id)">
                <b-icon class="mr-1" icon="pencil-square" />
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(data.item.id)"
              >
                <b-icon class="mr-1" icon="trash" />
                Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import ServerTable from '@/components/ServerTable'
import AddCompany from './Add'
import { saveAs } from 'file-saver'

export default {
  components: {
    InputFilter,
    ServerTable,
    AddCompany,
  },
  data() {
    return {
      loading: false,
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'name',
            label: 'Názov spoločnosti',
            formatter: (value, key, item) => item.name || '-',
            sortable: true,
            sortableKey: 'name',
            searchable: true,
          },
          {
            key: 'owner',
            label: 'Oprávnená osoba',
            formatter: (value, key, item) => item.owner || '-',
            sortable: true,
            sortableKey: 'owner',
            searchable: true,
          },
          {
            key: 'phone',
            label: 'Telefón',
            formatter: (value, key, item) => item.phone || '-',
            sortable: true,
            searchable: true,
          },
          {
            key: 'email',
            label: 'Email',
            formatter: (value, key, item) => item.email || '-',
            sortable: true,
            sortableKey: 'email',
            searchable: true,
          },
          {
            key: 'street',
            label: 'Adresa',
            formatter: (value, key, item) =>
              item.street ? item.street + ' ' + item.streetNumber : '-',
            sortable: true,
            sortableKey: 'street',
            searchable: true,
          },
          {
            key: 'city',
            label: 'Mesto',
            formatter: (value, key, item) => item.city || '-',
            sortable: true,
            sortableKey: 'city',
            searchable: true,
          },
          {
            key: 'regNumber',
            label: 'IČO',
            formatter: (value, key, item) => item.regNumber || '-',
            sortable: true,
            sortableKey: 'regNumber',
            searchable: true,
          },
          {
            key: 'taxRegNumber',
            label: 'IČ DPH',
            formatter: (value, key, item) => item.taxRegNumber || '-',
            sortable: true,
            sortableKey: 'taxRegNumber',
            searchable: true,
          },
        ],
        sortBy: 'name',
        filter: {},
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
    }
  },
  mounted() {
    this.$root.$on('reloadCompanyData', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('reloadCompanyData')
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('companies/get_list', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    openAddCompanyModal() {
      this.$root.$emit('modal-show', 'add-company')
    },
    edit(id) {
      this.$refs.companyForm.edit = true
      this.$refs.companyForm.form.id = id
      this.$nextTick(() => {
        this.openAddCompanyModal()
      })
    },
    remove(id) {
      this.$swal({
        title: 'Ste si istý?',
        text: 'Naozaj chcete odstrániť túto spoločnosť?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .post('companies/delete', {
              id: id,
            })
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.$refs.table.refresh()
            })
        }
      })
    },
    exportCompanies() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('companies/export', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'spolocnosti.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
    },
  },
}
</script>
